import React from "react";
import { useTranslation } from "react-i18next";

// requester comes populated from GET /fepks/mine, contact details included: only
// the EPK owner sees it (KIN-91). The public getuser route no longer has them.
export default function RequestCard({ Request }) {
  const { t } = useTranslation();
  const userInfo = Request.requester;

  const picture = userInfo?.picture?.startsWith("https")
    ? userInfo.picture
    : userInfo?.picture
    ? `${process.env.REACT_APP_AWS_URL}/${userInfo.picture}`
    : null;

  if (!userInfo) return null;

  return (
    <div className="tw-flex tw-items-center tw-gap-4 tw-py-2">
      <div className="tw-relative tw-flex-shrink-0">
        {picture && (
          <img
            className="tw-h-12 tw-w-12 tw-rounded-lg tw-object-cover"
            src={picture}
            alt={t("profile")}
          />
        )}
        <span className="tw-absolute tw-inset-x-0 tw-bottom-0 tw-rounded-b-lg tw-bg-black/50 tw-text-center tw-text-[9px] tw-text-white tw-leading-tight tw-py-0.5">
          {t(userInfo.role)}
        </span>
      </div>
      <div className="tw-min-w-0">
        <p className="tw-truncate tw-text-sm tw-font-semibold tw-text-white tw-m-0">
          {userInfo.firstName} {userInfo.lastName}
        </p>
        <p className="tw-truncate tw-text-xs tw-text-white/50 tw-m-0">{userInfo.email}</p>
        {userInfo.phone && <p className="tw-truncate tw-text-xs tw-text-white/40 tw-m-0">{userInfo.phone}</p>}
      </div>
    </div>
  );
}
